import { ISchedulerStateProps } from '../container-modal/ScheduleModal'

export const scheduleAppointment = (state: ISchedulerStateProps) => {
  throw new Error('implement me!')
}

export const getOrderVehicleByOrderId = (orderId: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/order_vehicles/byOrderObjectId??orderObjectId=${orderId}`,
  }
}

export const getOrderByOrderId = (orderId: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderId}`,
  }
}

export const setTimeSlot = (body: any, orderId: string) => {
  return {
    method: 'POST',
    body: body,
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderId}/time-slot`,
  }
}
export const rescheduleAppointment = (body: any, orderId: string) => {
  return {
    method: 'POST',
    body: body,
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderId}/reschedule`,
  }
}

export const getDirections = (locationId: string, placeId: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}/directions?placeId=${placeId}`,
  }
}
